import React, { useState, useEffect } from "react";
import {
  Table,
  Input,
  Tooltip,
  Button,
  DatePicker,
  Form,
  Switch,
  Modal,
  Checkbox,
  Select,
} from "antd";
import dayjs from "dayjs";
import moment from "moment";
const PremiumBlockInventories = ({
  handleEdit,
  handleDelete,
  premiumData,
  handleDateRangeChange,
  isDateBlocked,
  isMobile,
  discountCalc,
  handlePackageRateChange,
  handleSwitchChange,
  openInvs,
  handleCloseAllInv,
  handleOkOfAllInv,
  inputRef,
  searchText,
  handleFilterData,
  handleCheckboxChange,
  allInv,
  clientNames,
  handleEditPremiumData,
  reduxInvs,
}) => {
  const components = {
    header: {
      cell: (props) => (
        <th
          {...props}
          style={{
            ...props.style,
            backgroundColor: "#daeffe",
          }}
        />
      ),
    },
  };
  const columns = [
    {
      title: "Location Area",
      dataIndex: "location",
      key: "location",
      align: "center",
      // width: 150,
    },
    // {
    //   title: "RPM",
    //   dataIndex: "rpm",
    //   key: "rpm",
    //   // width: 150,
    //   editable: true,
    //   render: (_, record) => (
    //     <Input
    //       value={record.rpm}
    //       disabled={true}
    //       onChange={(e) => handleEdit(e.target.value, record._id, "rpm")}
    //     />
    //   ),
    // },
    // {
    //   title: "Special Rate Per Month",
    //   dataIndex: "specialRatePerMonth",
    //   key: "specialRatePerMonth",
    //   editable: true,
    //   // width: 600,
    //   render: (_, record) => (
    //     <Input
    //       disabled={
    //         premiumData?.packageRate || premiumData?.isPackageRateEnabled
    //       }
    //       value={record.specialRatePerMonth}
    //       onChange={(e) =>
    //         handleEdit(
    //           Number(e.target.value) || 0,
    //           record._id,
    //           "specialRatePerMonth"
    //         )
    //       }
    //     />
    //   ),
    // },
    // {
    //   title: "Special Rate",
    //   dataIndex: "specialRate",
    //   key: "specialRate",
    //   editable: true,
    //   // width: 600,
    //   render: (_, record) => (
    //     <Input
    //       disabled={
    //         premiumData?.packageRate || premiumData?.isPackageRateEnabled
    //       }
    //       value={record.specialRate}
    //       onChange={(e) =>
    //         handleEdit(Number(e.target.value) || 0, record._id, "specialRate")
    //       }
    //     />
    //   ),
    // },
    // {
    //   title: "Discount",
    //   dataIndex: "discount",
    //   key: "discount",
    //   render: (_, record) => (
    //     <div style={{ textAlign: "center" }}>
    //       {discountCalc(record?.specialRatePerMonth, record?.rpm)} %
    //     </div>
    //   ),
    // },
    {
      title: "Booking Period",
      dataIndex: "bookingPeriod",
      key: "bookingPeriod",
      align: "center",
      render: (_, record) => {
        const parseDate = (date) =>
          dayjs(date, "DD-MM-YYYY", true).isValid()
            ? dayjs(date, "DD-MM-YYYY")
            : dayjs(date); // fallback to try ISO or default parsing

        const rangeValue =
          record.startDate && record.endDate
            ? [parseDate(record.startDate), parseDate(record.endDate)]
            : null;
        // const rangeValue =
        //   record.startDate && record.endDate
        //     ? [
        //         dayjs(record.startDate, "DD-MM-YYYY"),
        //         dayjs(record.endDate, "DD-MM-YYYY"),
        //       ]
        //     : null;
        return (
          <div
            className="bdf-range-picker"
            style={{
              width: "fit-content",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            {!rangeValue && record.excelDates && (
              <div
                style={{
                  fontSize: 11,
                  color: "#d48806",
                  marginBottom: 4,
                  lineHeight: 1.3,
                }}
              >
                Excel dates: {record.excelDates.startDate} →{" "}
                {record.excelDates.endDate}
                <br />
                not available, pick new dates
              </div>
            )}
            <DatePicker.RangePicker
              value={rangeValue}
              format={"DD-MM-YYYY"}
              onChange={(dates, dateStrings) =>
                handleDateRangeChange(
                  dates,
                  dateStrings,
                  record._id,
                  record.Bookings
                )
              }
              disabledDate={(currentDate) =>
                isDateBlocked(
                  currentDate,
                  record.Bookings,
                  record?.blockedDates,
                  record?.premiumBlock,
                  record,
                )
              }
              cellRender={(currentDate) => {
                const dateString = currentDate.format("YYYY-MM-DD");
                const blockedDetail = record?.isOverlapPossible
                  ? null
                  : record.blockedDates?.find((block) => {
                    if (
                      !block?.blockedAt ||
                      !block?.blockedTill ||
                      block.archived === true
                    ) {
                      return false;
                    }
                    const start = moment(block.blockedAt).format("YYYY-MM-DD");
                    const end = moment(block.blockedTill).format("YYYY-MM-DD");
                    return dateString >= start && dateString <= end;
                  });
                const premiumDetail = record?.isOverlapPossible
                  ? null
                  : record.premiumBlock?.find(
                  ({ startDate, endDate }) => {
                    const start = moment(startDate).format("YYYY-MM-DD");
                    const end = moment(endDate).format("YYYY-MM-DD");
                    return dateString >= start && dateString <= end;
                  }
                );
                // Determine if premiumDetail should influence styling
                const isPremium = !!premiumDetail;

                const isBlockedDate = !!blockedDetail;
                const blockType = blockedDetail?.premiumBlock
                  ? "premium"
                  : blockedDetail?.managementBlock
                    ? "management"
                    : isBlockedDate
                      ? "normal"
                      : null;

                const blockedByName =
                  blockType === "premium"
                    ? blockedDetail?.blockedBy?.name
                    : blockType === "management"
                      ? "Management"
                      : null;

                const cellStyles = {
                  position: "relative",
                  zIndex: 1,
                  backgroundColor: isPremium
                    ? "#bd9595"
                    : blockType === "premium"
                      ? "#f39c12" // Default orange for premium in blockedDetail
                      : blockType === "management"
                        ? "#d3d3d3" // Darker gray for management
                        : blockType === "normal"
                          ? "#646363"
                          : "transparent",
                  color:
                    isPremium || blockType === "management"
                      ? "#000" // Black text for management or premiumDetail
                      : isBlockedDate
                        ? "#fff" // White text for other blocked types
                        : "inherit",
                  borderRadius: isBlockedDate || isPremium ? "50%" : "0",
                  width: isBlockedDate || isPremium ? "25px" : "auto",
                  height: isBlockedDate || isPremium ? "25px" : "auto",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  pointerEvents: "auto",
                };

                return (
                  <Tooltip
                    title={
                      isBlockedDate
                        ? blockType === "premium"
                          ? `Blocked by ${blockedByName}`
                          : blockType === "management"
                            ? `Blocked by Management`
                            : blockType === "normal"
                              ? "Blocked"
                              : ""
                        : premiumDetail
                          ? `Blocked by Premium`
                          : ""
                    }
                    placement="top"
                  >
                    <div style={cellStyles}>{currentDate.date()}</div>
                  </Tooltip>
                );
              }}
            />
          </div>
        );
      },
    },
    {
      title: "Action",
      // dataIndex: "specialRate",
      // key: "specialRate",
      align: "center",
      editable: true,
      render: (_, record) => (
        <div
          style={{
            width: "fit-content",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <Button onClick={() => handleDelete(record._id)}>Delete</Button>
        </div>
      ),
    },
  ];
  const columnsForInvs = [
    // {
    //     title: '_id',
    //     dataIndex: '_id',
    //     key: '_id'
    // },
    {
      title: "Location Area",
      dataIndex: "location",
      key: "location",
    },
    {
      title: "Width",
      dataIndex: "width",
      key: "width",
    },
    {
      title: "Height",
      dataIndex: "height",
      key: "height",
    },
    {
      title: "Illumination",
      dataIndex: "Illu",
      key: "Illu",
    },
    {
      title: "Add",
      dataIndex: "add",
      key: "add",
      render: (_, record) => (
        <Checkbox
          checked={record.checked}
          onChange={(e) => handleCheckboxChange(e, record)}
        />
      ),
    },
  ];
  console.log("🔔🔔", premiumData);
  return (
    <div className="bdf-table">
      <div>
        <Form>
          <div
            style={{
              display: "flex",
              flexWrap: "nowrap",
              gap: "0",
              width: "100%",
            }}
          >
            <Form.Item label="Client" style={{ flex: "1 1 0" }}>
              <Select
                options={clientNames}
                value={premiumData.blockedForName}
                onChange={(selected, option) => {
                  console.log("😆😆😆😆😆😆", option?.label);
                  handleEditPremiumData(option?.label, "blockedForName");
                  handleEditPremiumData(option?.value, "blockedForId");
                }}
                placeholder="Select a client"
                style={{ width: "70%" }}
                allowClear
                showSearch
                filterOption={(inputValue, option) =>
                  option.label.toLowerCase().includes(inputValue.toLowerCase())
                }
              />
            </Form.Item>
            <Form.Item label="Confirmed By" style={{ flex: "1 1 0" }}>
              <Input
                value={premiumData.confirmedBy}
                onChange={(e) =>
                  handleEditPremiumData(e.target.value, "confirmedBy")
                }
                style={{ width: "70%" }}
              />
            </Form.Item>
            <Form.Item label="Campaign name" style={{ flex: "1 1 0" }}>
              <Input
                value={premiumData?.campaignName?.toUpperCase() || ""}
                onChange={(e) =>
                  handleEditPremiumData(
                    e.target.value?.toUpperCase(),
                    "campaignName"
                  )
                }
                style={{ width: "70%" }}
              />
            </Form.Item>
          </div>
        </Form>
      </div>
      <div>
        <Table
          components={components}
          columns={columns}
          dataSource={premiumData?.inventories?.map((item) => {
            const fromRedux = reduxInvs?.find((r) => r._id === item._id);
            return {
              ...item,
              key: item._id,
              isOverlapPossible:
                item?.isOverlapPossible ??
                fromRedux?.isOverlapPossible ??
                false,
            };
          })}
        />
      </div>

      {/* {premiumData?.isPackageRateEnabled && (
        <Form>
          <Form.Item label="Package Rate">
            <Input
              value={Number(premiumData.packageRate) || 0}
              onChange={(e) =>
                handlePackageRateChange(Number(e.target.value) || 0)
              }
            />
          </Form.Item>
        </Form>
      )}
      <Switch
        checked={premiumData.isPackageRateEnabled}
        checkedChildren="Package Rate"
        unCheckedChildren="Package Rate"
        onChange={handleSwitchChange}
      /> */}
      <Modal
        title="Choose Inventories"
        open={openInvs}
        onOk={handleOkOfAllInv}
        onCancel={handleCloseAllInv}
        width={900}
      >
        <Input
          ref={inputRef}
          placeholder="Search Any Field"
          value={searchText}
          onChange={(e) => handleFilterData(e)}
        />
        <div style={{ width: "100%", margin: "20px 0px" }}>
          <Table dataSource={allInv} columns={columnsForInvs} rowKey="invId" />
        </div>
      </Modal>
    </div>
  );
};
export default PremiumBlockInventories;
